import {
  openSuccess,
  openError,
  openInfo,
} from '../../neb-dialog/neb-banner-state';

import { Method } from './utils/api-client-utils';
import ApiClientV2 from './utils/api-client-v2';

const coreApiClient = new ApiClientV2({
  microservice: 'core',
});

const POLL_INTERVAL_MS = 5000;
const MAX_POLL_TIME_MS = 6000000;

const startAuditJob = async ({ chartNotes, chargeList, diagnosesList }) => {
  const response = await coreApiClient.makeRequest({
    method: Method.POST,
    headers: { 'Content-Type': 'application/json' },
    path: '/api/v1/tenants/:tenantId/audit-shield/soap-audit',
    body: { ...chartNotes, chargeList, diagnosesList },
  });

  return response.data[0].job_id;
};

const getAuditStatus = async jobId => {
  const response = await coreApiClient.makeRequest({
    method: Method.GET,
    replacements: { jobId },
    path: '/api/v1/tenants/:tenantId/audit-shield/soap-audit/:jobId',
  });

  return response.data[0];
};

const waitForAuditComplete = jobId => {
  const startTime = Date.now();

  return new Promise((resolve, reject) => {
    const checkStatus = async () => {
      try {
        const data = await getAuditStatus(jobId);

        if (data.status === 'done') {
          resolve(data.result);
          return;
        }

        if (data.status === 'error') {
          reject(new Error('Audit processing failed'));
          return;
        }

        if (Date.now() - startTime > MAX_POLL_TIME_MS) {
          reject(new Error('Audit timed out'));
          return;
        }

        setTimeout(checkStatus, POLL_INTERVAL_MS);
      } catch (error) {
        reject(error);
      }
    };

    checkStatus();
  });
};

export const auditEncounterAsync = async ({
  chartNotes,
  chargeList,
  diagnosesList,
  onStatus,
}) => {
  try {
    const jobId = await startAuditJob({
      chartNotes,
      chargeList,
      diagnosesList,
    });
    console.log('jobId :>> ', jobId);
    openInfo('Audit started. You will be notified when complete.');
    if (onStatus) onStatus('pending');

    waitForAuditComplete(jobId)
      .then(result => {
        openSuccess('Audit process completed successfully');
        if (onStatus) onStatus('done', result);
        return result;
      })
      .catch(error => {
        openError(error.message || 'Audit process failed');
        if (onStatus) onStatus('error', error);
        console.error('Audit process error:', error);
      });
  } catch (error) {
    openError('Failed to start audit');
    if (onStatus) onStatus('error', error);
    console.error('Audit start error:', error);
  }
};

export const saveAuditResults = async ({ encounterId, shieldData }) => {
  const response = await coreApiClient.makeRequest({
    method: Method.POST,
    headers: { 'Content-Type': 'application/json' },
    replacements: { encounterId },
    path: '/api/v1/tenants/:tenantId/audit-shield/:encounterId',
    body: { shieldData },
  });

  return response;
};
